import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-gray-800 text-white mt-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        <div>
          <h3 className="font-bold text-lg mb-3 text-emerald-300">Gbongan Archive</h3>
          <p className="text-gray-400 text-sm leading-relaxed">
            A digital platform preserving the history, culture, and achievements of the Gbongan community.
          </p>
          <p className="text-sm italic text-emerald-400 mt-2">...where history meets the future...</p>
        </div>
        <div>
          <h3 className="font-bold text-sm mb-3 text-gray-300 uppercase tracking-wider">Sections</h3>
          <ul className="space-y-1.5 text-sm text-gray-400">
            {[['/', 'Home'], ['/archive', 'Archive'], ['/news', 'News'], ['/history-heritage', 'History & Heritage'], ['/map', 'Map'], ['/chatroom', 'Global Chatroom'], ['/credits', 'Admin & Credits']].map(([to, label]) => (
              <li key={to}><Link to={to} className="hover:text-emerald-300 transition">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-bold text-sm mb-3 text-gray-300 uppercase tracking-wider">Contribute</h3>
          <ul className="space-y-1.5 text-sm text-gray-400">
            {[['archive','Archive Contribution'],['news','News Submission'],['person','Person Profile'],['contact','Contact Us']].map(([type, label]) => (
              <li key={type}><Link to={`/contribute/${type}`} className="hover:text-emerald-300 transition">{label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-700 pt-6 text-center space-y-3">
        <p className="text-sm font-semibold">© 2026 Gbongan Archive. All rights reserved.</p>
        <p className="text-gray-500 text-xs">Built to connect history to the future</p>
        <div className="inline-block bg-yellow-900/30 border border-yellow-600/50 rounded-lg px-4 py-2">
          <p className="text-yellow-300 text-xs font-medium">🚧 Site Under Construction – Some features may be in development.</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
